function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
import InfoIcon from 'svg/info.svg';
var _React_PureComponent;
class InfoTooltip extends (_React_PureComponent = React.PureComponent) {
    get tooltipText() {
        return isObjectLike(this.props.message) ? this.props.intl.formatMessage(this.props.message, _object_spread({}, this.props.message.values)) : this.props.message;
    }
    render() {
        const { tooltipText } = this;
        if (!tooltipText) {
            return null;
        }
        return /*#__PURE__*/ _jsx("span", {
            className: "info-tooltip ml-3",
            "data-for": this.props.tooltipId,
            "data-tip": tooltipText,
            children: /*#__PURE__*/ _jsx(InfoIcon, {})
        });
    }
}
_define_property(InfoTooltip, "propTypes", {
    // Explicit props
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    tooltipId: PropTypes.string,
    // Implicit props
    intl: intlShape.isRequired
});
_define_property(InfoTooltip, "defaultProps", {
    tooltipId: 'globalTooltip'
});
export default injectIntl(InfoTooltip);
